import { Component, Input, OnInit } from '@angular/core';
import { Customer } from 'gung-standard';
import { HlDisplayDeliveryAddressesListConfigService } from '../../services/hl-display-delivery-addresses-list-config.service';
import { HlDisplayModalService } from '../../services/hl-display-modal.service';

@Component({
  selector: 'app-hl-display-pod-customer-details',
  templateUrl: './hl-display-pod-customer-details.component.html',
  styleUrl: './hl-display-pod-customer-details.component.css',
  standalone: false
})
export class HlDisplayPodCustomerDetailsComponent implements OnInit {
  @Input() customer: Customer;

  constructor(
    public configService: HlDisplayDeliveryAddressesListConfigService,
    protected hlDisplayModalService: HlDisplayModalService
  ) {}

  ngOnInit(): void {
    if (!this.customer) {
      throw new Error('No customer');
    }
    this.configService.customerSubject.next(this.customer);
  }

  public openAddPOD(): void {
    this.hlDisplayModalService.openAddEditHlDisplayDeliveryLocation(this.customer.id).then(
      result => {
        console.log('yoyo');
        this.configService.customerSubject.next(this.customer);
      },
      () => {
        console.log('adadad');
      }
    );
  }
}
